var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Nav"},[_c('router-link',{staticClass:"nav-item",attrs:{"to":"/goods"}},[_vm._v("\n  商品\n  "),_c('i',{staticClass:"line"})]),_vm._v(" "),_c('router-link',{staticClass:"nav-item",attrs:{"to":"/seller"}},[_vm._v("\n  商家(货机号："+_vm._s(_vm.machineId)+"）\n  "),_c('i',{staticClass:"line"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f9bebf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav/Nav.vue
// module id = null
// module chunks = 